import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../api';
import {
  EmptyState,
  ErrorBox,
  Loader,
  PageHeader,
  formatDateTime,
} from '../../components/Common';

export function AdminMastersPage() {
  const queryClient = useQueryClient();
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['admin-pending-masters'],
    queryFn: api.admin.pendingMasters,
  });

  const approve = useMutation({
    mutationFn: (id: string) => api.admin.approveMaster(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin-pending-masters'] }),
  });
  const reject = useMutation({
    mutationFn: (id: string) => api.admin.rejectMaster(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin-pending-masters'] }),
  });

  return (
    <div>
      <PageHeader title="Заявки мастеров" />

      {isLoading && <Loader />}
      {error && <ErrorBox message={(error as Error).message} onRetry={() => void refetch()} />}
      {!isLoading && data && data.length === 0 && (
        <EmptyState icon="📨" title="Нет новых заявок" />
      )}

      <ul className="space-y-2">
        {data?.map((a) => (
          <li key={a.id} className="card space-y-2">
            <div>
              <p className="font-semibold">{a.full_name}</p>
              <p className="text-xs text-tg-hint">{a.phone}</p>
              <p className="text-xs text-tg-hint">Подана: {formatDateTime(a.created_at)}</p>
            </div>
            {a.experience && (
              <p className="text-sm">
                <span className="text-tg-hint">Опыт:</span> {a.experience}
              </p>
            )}
            {a.about && (
              <p className="text-sm">
                <span className="text-tg-hint">О себе:</span> {a.about}
              </p>
            )}
            <div className="flex gap-2">
              <button
                className="btn-primary flex-1"
                disabled={approve.isPending}
                onClick={() => approve.mutate(a.id)}
              >
                Одобрить
              </button>
              <button
                className="btn-secondary flex-1"
                disabled={reject.isPending}
                onClick={() => reject.mutate(a.id)}
              >
                Отклонить
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
